// UsuariosRegistrados.jsx
import React, { useEffect, useState } from 'react';
import axios from 'axios';

function UsuariosRegistrados() {
  const [usuarios, setUsuarios] = useState([]);

  useEffect(() => {
    axios
      .get('https://pedidos.ayvgas.cl/telegram/getUsers.php')
      .then((response) => {
        setUsuarios(response.data);
      })
      .catch((error) => {
        console.error('Error al obtener los usuarios:', error);
      });
  }, []);

  return (
    <div>
      <h2>Usuarios Registrados</h2>
      <table>
        <thead>
          <tr>
            <th>ID de Usuario</th>
            <th>Nombre</th>
            <th>Dirección</th>
            <th>Teléfono</th>
          </tr>
        </thead>
        <tbody>
          {usuarios.map((usuario, index) => (
            <tr key={index}>
              <td>{usuario.user_id}</td>
              <td>{usuario.first_name}</td>
              <td>{usuario.address}</td>
              <td>{usuario.phone}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default UsuariosRegistrados;
